import { Component, inject, OnInit } from '@angular/core';
import { ThreeColumnTemplateComponent } from '@templates/three-column-template/three-column-template.component';
import { TranslateModule } from '@ngx-translate/core';
import { IPublications_Response } from '@shared/constants/models.const';
import { HelperService } from '../../services/helper.service';
import { ContentService } from '../../services/content.service';
import {
  PublicationCardComponent,
  PublicationsType,
} from '../home/components/latest-publications-section/components/publication-card/publication-card.component';
import { PaginatorComponent } from '@shared/components/paginator/paginator.component';

@Component({
  selector: 'app-related-publications',
  imports: [
    ThreeColumnTemplateComponent,
    TranslateModule,
    PublicationCardComponent,
    PaginatorComponent,
  ],
  templateUrl: './related-publications.component.html',
  styleUrl: './related-publications.component.scss',
})
export class RelatedPublicationsComponent implements OnInit {
  pageData!: IPublications_Response | undefined;
  readonly HELPER: HelperService = inject(HelperService);
  readonly CONTENT: ContentService = inject(ContentService);
  protected readonly PublicationsType = PublicationsType;
  prevTitle = '';

  ngOnInit(): void {
    const prevUrl = this.HELPER.getLastUrl(true);
    this.prevTitle = this.HELPER.getLastTitle() || 'Publications';
    this.getData(prevUrl);
    this.HELPER.$onReload.subscribe(() => {
      this.getData(prevUrl);
    });

  }

  getData(url = 'publications'): void {
    this.pageData = undefined;
    this.CONTENT.getPageByUrl(
      url,
      this.HELPER.getProps(),
    ).subscribe(res => {
      this.pageData = res as IPublications_Response;
    });
  }

  goBack() {
    this.HELPER.goLastUrl();
  }
}
